<template>
    <card minify="true">
        <card-header>
            <card-subtitle>{{ askForQuote.pfnumber }} - {{
                    askForQuote.project_name
                }}
            </card-subtitle>
        </card-header>
        <card-content>
            <div class="row">
                <div class="col">
                    <sketch-preview :sketchFile="sketchFile"/>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <description-group grid="true">
                        <description-element v-if="askForQuote.client_sketch_file"
                                             :caption="sketchFileName" :link="sketchFileLink"
                                             :title="this.$gettext('Zeichnung')"  icon="document-file-download"/>
                        <description-element v-if="askForQuote.client_cad_file"
                                             :caption="cadFileName" :link="cadFileLink"
                                             :title="this.$gettext('3D-Daten')"  icon="document-file-download"/>
                    </description-group>
                </div>
            </div>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardSubtitle from '@partfactory/Shared/Card/CardSubtitle';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import SketchPreview from '@partfactory/Shared/Elements/SketchPreview';

export default {
    name: 'ComponentSidebarSketch',
    components: {
        SketchPreview,
        DescriptionGroup,
        DescriptionElement, CardSubtitle, CardContent, CardHeader, Card},
    props: {
        askForQuote: Object,
    },
    computed: {
        sketchFile() {
            return this.askForQuote.client_sketch_file;
        },
        sketchFileName() {
            return this.askForQuote.client_sketch_file.file_informations.original_name;
        },
        sketchFileLink() {
            return this.$$route('sketch-file.download', {'sketchFile': this.askForQuote.client_sketch_file.id});
        },
        cadFile() {
            return this.askForQuote?.client_cad_file;
        },
        cadFileName() {
            return this.askForQuote?.client_cad_file.file_informations.original_name;
        },
        cadFileLink() {
            return this.$$route('cad-file.download', {'cadFile': this.askForQuote.client_cad_file.id});
        },
    }
};
</script>

<style scoped>

</style>
